/**
 * Run a sync fn, swallowing errors and returning null. Sync APIs only (e.g.
 * sessionStorage): an async fn returns its Promise before it can reject, so
 * try/catch never fires — use `safeAsync` for Promises.
 */
export const safe = <T>(fn: () => T, label?: string): T | null => {
  try {
    return fn();
  } catch (e) {
    if (label) console.error(`[tabStorage] ${label} failed:`, e);
    return null;
  }
};

/** Async `safe`: awaits inside try so rejections are caught. `label` names the op in logs. */
export const safeAsync = async <T>(
  fn: () => Promise<T>,
  label?: string
): Promise<T | null> => {
  try {
    return await fn();
  } catch (e) {
    if (label) console.error(`[tabStorage] ${label} failed:`, e);
    return null;
  }
};
